import React from 'react';

import { Icon } from '@rbilabs/components-library';
import styled from 'styled-components';

import { LinkNoDecoration } from 'components/app-header/mobile-header/styled';
import { useFeatureNavigation } from 'hooks/use-feature-navigation';
import { useReversedUIContext } from 'state/reversed-ui';

export const HamburgerContainer = styled.div`
  position: fixed;
`;

export const HamburgerButton: React.FC<{ className?: string }> = ({ className }) => {
  const { featureNavigationMobileHeaderButton } = useFeatureNavigation();
  const { reversedUI } = useReversedUIContext();

  const iconColor = reversedUI ? 'icon-reversed' : 'icon-header-contrast';

  return featureNavigationMobileHeaderButton ? (
    <HamburgerContainer className={className}>
      <LinkNoDecoration to={featureNavigationMobileHeaderButton?.link?.locale ?? ''}>
        <Icon icon="menu" color={iconColor} width="1.5rem" aria-hidden />
      </LinkNoDecoration>
    </HamburgerContainer>
  ) : null;
};
